
import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';

import {ReportsService} from './reports.service';

@Injectable()
export class ReportsResolver implements Resolve<any> {

  constructor(private reportsService: ReportsService) {
  }

  resolve(route: ActivatedRouteSnapshot,
          state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    return this.reportsService.reportsSack;
  }

}



// WEBPACK FOOTER //
// ./src/app/report/reports/reports-resolver.service.ts